import { CpOrderInvoicesDataItem } from '../list/cp_order_invoices_list_types';
import { CpOrderInvoicesDetailsPageState } from './cp_order_invoices_details_types';

// PAGE
export function cpOrderInvoicesDetailsPageStateVM(): CpOrderInvoicesDetailsPageState {
    return {
        waiting: false,
        init: true,
        title: '',
        canEdit: false,
        id: '',
        rebatesOnly: false,
        userType: '',
        userAffList: [],
        hasTrueUpFeature: false,
        isVeriSaveOnly: false,
    };
}

// MODEL
export function cpOrderInvoicesDetailsModelVM(): CpOrderInvoicesDataItem {
    return {
        Id: '',
        CEID: '',
        Pharmacy: '',
        AccumGrp: '',
        OrderNum: '',
        CreatedDate: '',
        Type: '',
        VendorName: '',
        VendorInvoiceNum: '',
        VendorInvoiceDate: '',
        BillNumber: '',
        InvoiceReconciledDate: '',
        TotalAmount: 0,
        Reviewer: '',
        Items: [],
        IsRebate: false,
        AccumRXID: '',
    };
}
